import { Component, OnInit } from '@angular/core';
import { GitlabService } from '../gitlab.service';

@Component({
  selector: 'app-dashboards',
  templateUrl: './dashboards.component.html',
  styleUrls: ['./dashboards.component.css']
})
export class DashboardsComponent implements OnInit {

  gitlabInstances: string[];

  constructor(private gitlabService: GitlabService) {
  }

  ngOnInit() {
    this.gitlabService.getInstanceNames()
      .subscribe(names => {
        this.gitlabInstances = names;
        this.loadDashboards();
      })
  }

  private loadDashboards() {

  }
}
